import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";

function padTo2Digits(num) {
  return num.toString().padStart(2, "0");
}

function formatDate(date) {
  return [date.getFullYear(), padTo2Digits(date.getMonth() + 1), padTo2Digits(date.getDate())].join("-");
}

const initialState = {
  data: {
    importscompliancedata: {
      countryofimport: ["US"],
      countryofexport: "",
      countryofmanufacture: "",
      date: formatDate(new Date()),
      hscode: "",
    },
    submitbutton: false,
    hscodeempty: false,
    importscomplianceresults: [],
    importsembargoesresults: [],
    totalcompliances: 0,
    totalembargoes: 0,
  },
};

const importsComplianceSlice = createSlice({
  name: "importscompliancedata",
  initialState,
  reducers: {
    storeImportsComplianceData(state, action) {
      switch (action.payload.type) {
        case "import":
          state.data.importscompliancedata.countryofimport = action.payload.selectedvalue;
          break;

        case "export":
          state.data.importscompliancedata.countryofexport = action.payload.selectedvalue;
          break;

        case "manufacture":
          state.data.importscompliancedata.countryofmanufacture = action.payload.selectedvalue;
          break;

        case "hscode":
          state.data.importscompliancedata.hscode = action.payload;
          break;

        case "totalcompliances":
          state.data.totalcompliances = action.payload.selectedvalue;
          break;

        case "totalembargoes":
          state.data.totalembargoes = action.payload.selectedvalue;
          break;

        case "date":
          state.data.importscompliancedata.date = moment(action.payload.value).format("YYYY-MM-DD");

          break;

        default:
          break;
      }
    },
    captureImportsComplianceButtonClick(state, action) {
      state.data.submitbutton = action.payload;
    },
    storeImportsComplianceResults(state, action) {
      state.data.importscomplianceresults = action.payload;
    },
    storeImportsEmbargoesResults(state, action) {
      state.data.importsembargoesresults = action.payload;
    },
    appendImportsComplianceResults(state, action) {
      state.data.importscomplianceresults = [...state.data.importscomplianceresults, ...action.payload];
    },
    detectHSCodeEmptyImportsCompliance(state, action) {
      state.data.hscodeempty = action.payload;
    },
  },
});

export const {
  storeImportsComplianceData,
  captureImportsComplianceButtonClick,
  storeImportsComplianceResults,
  appendImportsComplianceResults,
  detectHSCodeEmptyImportsCompliance,
  storeImportsEmbargoesResults,
} = importsComplianceSlice.actions;

export default importsComplianceSlice.reducer;
